import { Box } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import { Spinner } from 'components/elements/Spinner';
import { FlexRow } from 'components/layout/FlexRow';

const toastContentStyle = {
  backgroundColor: Colors.White,
  color: Colors.Black,
  borderRadius: '4px',
  padding: 'padding_8',
  justifyContent: 'normal',
};

const boxSize = {
  width: '50px',
};

type TLoadingToastProps = {
  label: string;
};

const LoadingToast = ({ label }: TLoadingToastProps) => {
  return (
    <FlexRow sx={toastContentStyle}>
      <Box sx={boxSize}>
        <Spinner size="sm" />
      </Box>
      <Text.Body>{label}</Text.Body>
    </FlexRow>
  );
};

export default LoadingToast;
